import { IFile, IMailPecMail } from '../../shared/interfaces'

export interface MailProtocolWizardReduxState {
    lateralPanelMailProtocolWizardIsOpen: boolean

    selectedMailboxAddress: string | undefined
    selectedMail: IMailPecMail | undefined
    selectedDocument: IFile | undefined
    fileListOptions: IFile[] | undefined
}

export const SET_INITIAL_STATE = 'SET_INITIAL_STATE'
interface SetInitialStateAction {
    type: typeof SET_INITIAL_STATE
}
export const UPDATE_MAIL_PROTOCOL_WIZARD_STATE = 'UPDATE_MAIL_PROTOCOL_WIZARD_STATE'
interface UpdateMailProtocolWizardStateAction {
    type: typeof UPDATE_MAIL_PROTOCOL_WIZARD_STATE
    payload: Partial<MailProtocolWizardReduxState>
}
export type MailProtocolWizardActionTypes = SetInitialStateAction | UpdateMailProtocolWizardStateAction